module.exports = __webpack_public_path__ + "static/media/war-redblue.231992ea.PNG";